// Helper functions for call routing
import type { CallRoutingElement, ToastType } from './types'

/**
 * Deletes an entry from an array by index
 */
export const deleteEntryByIndex = <T>(array: T[], index: number): T[] => {
    return array.filter((_, i) => i !== index)
}

/**
 * Updates an entry in an array at a specific index
 */
export const updateEntryAtIndex = <T>(array: T[], index: number, newValue: T): T[] => {
    return array.map((item, i) => i === index ? newValue : item)
}

/**
 * Finds the default element in the call routing configuration
 */
export const findDefaultElement = (elements: CallRoutingElement[]): CallRoutingElement | null => {
    return elements.find(element => element.defaultElement) || null
}

/**
 * Gets exception elements (non-default elements)
 */
export const getExceptionElements = (elements: CallRoutingElement[]): CallRoutingElement[] => {
    return elements.filter(element => !element.defaultElement)
}

/**
 * Creates a new default call routing element
 */
export const createDefaultElement = (): CallRoutingElement => {
    return {
        defaultElement: true,
        utteranceToSpeak: '',
        utteranceLanguage: 'en',
        goodbyeUtteranceToSpeak: '',
        goodbyeUtteranceLanguage: 'en'
    }
}

/**
 * Validates a call routing element
 */
export const validateCallRoutingElement = (element: CallRoutingElement): boolean => {
    return (
        typeof element === 'object' &&
        typeof element.defaultElement === 'boolean'
    )
}

/**
 * Mock toast functions - replace with actual toast implementation
 */
export const showToast = (message: string, type: ToastType = 'success') => {
    console.log(`Toast ${type}:`, message)
}

// Specific toast functions for call routing operations
export const showToastDeleteCallRoutingException = (message?: string) => {
    showToast(message || 'Call routing exception deleted successfully', 'success')
}

export const showToastDeleteCallRoutingObject = (message?: string) => {
    showToast(message || 'Call routing object deleted successfully', 'success')
}

export const showToastErrorModifyCallRoutingObject = (message?: string) => {
    showToast(message || 'Error modifying call routing object', 'error')
}

export const showToastNewCallRoutingObject = (message?: string) => {
    showToast(message || 'New call routing object created successfully', 'success')
}

export const showToastUpdateCallRoutingExceptionTime = (message?: string) => {
    showToast(message || 'Call routing exception time updated successfully', 'success')
}

export const showToastUpdateCallRoutingObject = (message?: string) => {
    showToast(message || 'Call routing object updated successfully', 'success')
}

export const showToastUpdateGoodbyeMessage = (message?: string) => {
    showToast(message || 'Goodbye message updated successfully', 'success')
}

export const showToastUpdateGreetingMessage = (message?: string) => {
    showToast(message || 'Greeting message updated successfully', 'success')
}